import React from 'react';
import { Box, Typography } from '@mui/material';

const MetaData = ({ meta }) => (
    <Box sx={{ mt: 2 }}>
        <Typography variant="subtitle1" sx={{ color: '#12c099', mb: 1 }}>Meta Data:</Typography>
        {Object.entries(meta).map(([key, val]) => (
            <Typography key={key} variant="body2" sx={{ color: '#eee' }}>
                • {key}: {val}
            </Typography>
        ))}
    </Box>
);

export default MetaData;
